"use strict";
// https://document.microcms.io/manual/field-extension
exports.__esModule = true;
var MessageContextTypeValue = {
    NEW_CONTENT: "new_content",
    EDIT_CONTENT: "edit_content"
};
